/**
 * @generated SignedSource<<d1a4928f9299349a675ef725b9b34a0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newsletterArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentNewsletterArticleArticle" | "headerNewsletterArticleArticle" | "issuesNewsletterArticleArticle" | "widgetNewsletterArticleArticle">;
  readonly " $fragmentType": "newsletterArticleArticle";
};
export type newsletterArticleArticle$key = {
  readonly " $data"?: newsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"newsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "newsletterArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "issuesNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "widgetNewsletterArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "876df60ff2f7b93c0c98303fac90fedd";

export default node;
